<script setup lang="ts">
import { ref } from "vue";
import { useToast } from "primevue/usetoast";

const props = defineProps<{
  value: string;
  label?: string;
  emptyText?: string;
}>();

const toast = useToast();
const copying = ref(false);
const isHovering = ref(false);

const copyToClipboard = async () => {
  if (!props.value || props.value === props.emptyText) return;

  copying.value = true;
  try {
    await navigator.clipboard.writeText(props.value);
  } catch (err) {
    toast.add({ severity: "error", summary: "Failed to copy", life: 2000 });
  }
  setTimeout(() => {
    copying.value = false;
  }, 1000);
};
</script>

<template>
  <div
    class="inline-flex items-center relative group w-full"
    @mouseenter="isHovering = true"
    @mouseleave="isHovering = false"
  >
    <span
      v-if="label"
      class="mr-2 text-gray-500"
    >{{ label }}:</span>

    <div
      class="inline-flex items-center cursor-pointer border-b border-dotted border-gray-400 hover:border-primary transition-colors relative"
      @click="copyToClipboard"
    >
      <span>{{ value || emptyText || 'N/A' }}</span>

      <div
        v-if="isHovering && value && value !== emptyText"
        class="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity z-50 pointer-events-none"
      >
        <span v-if="!copying">Click to copy</span>
        <span v-else>Copied!</span>
        <div class="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-800"></div>
      </div>
    </div>
  </div>
</template>
